<template>
  <div class="Navbar">
    <nav class="navbar navbar-expand-lg bg-body-tertiary fixed-top border-bottom"
      :class="{ 'mt-4': usuario.id && usuario.idEmpresaSeleccionada }" id="Navbar">
      <div class="container-fluid">
        <a href="javascript:void(0)" class="navbar-brand">
          <img src="@/assets/img/general_logo.webp" alt="GoodBzz" width="140" />
        </a>
        <!-- OFFCANVAS - MODULOS -->
        <div class="offcanvas bg-body-tertiary offcanvas-bottom border-bottom" id="navbarOffcanvas" tabindex="-1"
          aria-labelledby="offcanvasNavbarLabel">
          <div class="offcanvas-body">
            <div class="navbar-nav justify-content-center align-items-center flex-grow-1 scroll-navbar">
              <template v-if="!usuario.id">
                <router-link class="nav-item nav-link" :to="{ name: 'Login' }">
                  <li data-bs-dismiss="offcanvas" aria-label="Close">
                    <ion-icon name="log-in-outline" class="text-dark hidden"></ion-icon>Ingresar
                  </li>
                </router-link>
                <hr />
                <router-link class="nav-item nav-link" :to="{ name: 'Registrarse' }">
                  <li data-bs-dismiss="offcanvas" aria-label="Close">
                    <ion-icon name="person-add" class="text-dark hidden"></ion-icon>Únete
                  </li>
                </router-link>
              </template>
              <template v-else>
                <!--<router-link class="nav-item nav-link hidden" :to="{ name: 'Inicio' }">
                  <li data-bs-dismiss="offcanvas" aria-label="Close">
                    <i class="fas fa-home text-dark"></i>Inicio
                  </li>
                </router-link>-->
                <!--<hr class="d-none" />
                <router-link class="nav-item nav-link" :to="{ name: 'Comunidad' }">
                  <li data-bs-dismiss="offcanvas" aria-label="Close">
                    <img src="@/assets/img/navbar_icono_comunidad.webp" class="img-fluid img-community hidden"
                      width="25px" />Comunidad
                  </li>
                </router-link>
                <hr />-->
                <router-link class="nav-item nav-link" :to="{ name: 'Empresas' }">
                  <li data-bs-dismiss="offcanvas" aria-label="Close">
                    <i class="fas fa-building hidden"></i>Empresas
                  </li>
                </router-link>
                <hr />
                <router-link class="nav-item nav-link" :to="{ name: 'MatrizLegalDev' }">
                  <li data-bs-dismiss="offcanvas" aria-label="Close">
                    <img src="@/assets/img/navbar_icono_matriz_legal.webp" class="img-fluid img-matrix-legal hidden"
                      width="23px" />
                    Matriz Legal
                  </li>
                </router-link>
                <hr />
                <router-link class="nav-item nav-link" :to="{ name: 'ActividadesPanel' }">
                  <li data-bs-dismiss="offcanvas" aria-label="Close">
                    <ion-icon name="newspaper" class="text-dark hidden"></ion-icon>Actividades
                  </li>
                </router-link>
                <!--<router-link class="nav-item nav-link d-none" :to="{ name: 'VinculacionesEmpresa' }">
                  <li data-bs-dismiss="offcanvas" aria-label="Close">
                    <ion-icon name="people" class="text-dark hidden"></ion-icon>Vinculaciones
                  </li>
                </router-link>
                <hr class="d-none" />
                <router-link class="nav-item nav-link d-none" :to="{ name: 'Asesorias' }">
                  <li data-bs-dismiss="offcanvas" aria-label="Close">
                    <ion-icon name="people-circle" class="text-dark hidden"></ion-icon>Asesorías
                  </li>
                </router-link>
                <hr class="d-none" />
                <a class="nav-item nav-link d-none" href="javascript:void(0)">
                  <li data-bs-dismiss="offcanvas" aria-label="Close" @click="irReporteSGSST()">
                    <ion-icon name="newspaper" class="text-dark hidden"></ion-icon>Reporte SG-SST
                  </li>
                </a>-->
                <div class="dropdown ms-2 me-2 display">
                  <a type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <img :src="usuario.foto ? usuario.foto : $store.state.imagenes.defecto.foto" alt="" class="rounded-circle img-fluid" width="35" />
                  </a>
                  <ul class="dropdown-menu">
                    <!--<li class="d-none">
                      <router-link class="dropdown-item" :to="{ name: 'MiPerfil' }">
                        Mi Perfil
                      </router-link>
                    </li>
                    <li class="d-none">
                      <router-link class="dropdown-item" :to="{ name: 'SolicitudesVinculacion' }">
                        Solicitudes de Vinculación
                      </router-link>
                    </li>-->
                    <li>
                      <a class="dropdown-item" href="#" @click="cerrarSesion()">Cerrar Sesión</a>
                    </li>
                  </ul>
                </div>
              </template>
              <!--<hr />
              <router-link class="nav-item nav-link" :to="{ name: 'SoporteTecnico' }">
                <li data-bs-dismiss="offcanvas" aria-label="Close">
                  <img src="@/assets/img/navbar_icono_soporte_tecnico.webp" class="img-fluid img-support" width="25px" />
                  <span class="hidden">Soporte Técnico</span>
                </li>
              </router-link>
              <hr />
              <router-link class="nav-item nav-link" :to="{ name: 'Ayuda' }">
                <li data-bs-dismiss="offcanvas" aria-label="Close">
                  <ion-icon name="help-circle" class="text-dark"></ion-icon>
                  <span class="hidden">Ayuda</span>
                </li>
              </router-link>-->
            </div>
            <div class="d-flex align-items-center justify-content-between theme">
              <a class="nav-item nav-link me-2" aria-current="page" href="javascript:void(0)">
                {{ $store.state.version }}
              </a>
              <SwitchApariencia />
            </div>
          </div>
        </div>
        <!-- PERFIL - NAVBAR (MOVIL) -->
        <a v-if="usuario.id" class="hidden" href="javascript:void(0)" data-bs-toggle="offcanvas"
          data-bs-target="#profileOffcanvas" aria-controls="profileOffcanvas" aria-expanded="false"
          aria-label="Abrir Perfil">
          <img :src="usuario.foto ? usuario.foto : $store.state.imagenes.defecto.foto" alt="" class="rounded-circle img-fluid me-2" width="40" />
        </a>
        <!-- BOTON - NAVBAR -->
        <button class="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#navbarOffcanvas"
          aria-controls="navbarOffcanvas" aria-expanded="false" aria-label="Abrir Menú">
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
      <!-- OFFCANVAS - PERFIL -->
      <div class="offcanvas bg-body-tertiary offcanvas-bottom border-bottom" id="profileOffcanvas" tabindex="-1"
        aria-labelledby="profileOffcanvasLabel">
        <div class="offcanvas-body">
          <div class="navbar-nav scroll-profile">
            <!--<router-link class="nav-item nav-link hidden d-none" :to="{ name: 'MiPerfil' }">
              <li data-bs-dismiss="offcanvas" aria-label="Close">
                <img src="@/assets/img/navbar_icono_mi_perfil.webp" class="img-fluid img-profile" width="25px" />Mi Perfil
              </li>
            </router-link>
            <hr class="d-none" />
            <router-link class="nav-item nav-link hidden d-none" :to="{ name: 'SolicitudesVinculacion' }">
              <li data-bs-dismiss="offcanvas" aria-label="Close">
                <ion-icon name="git-pull-request"></ion-icon>Solicitudes de Vinculación
              </li>
            </router-link>-->
            <hr class="d-none" />
            <a class="nav-item nav-link hidden" data-bs-dismiss="offcanvas" aria-label="Close" @click="cerrarSesion()">
              <img src="@/assets/img/navbar_icono_cerrar_sesion.webp" class="img-fluid img-logout" width="25px" />Cerrar
              Sesión
            </a>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import { auth, db } from "@/firebase";
import {
  collection,
  doc,
  onSnapshot,
  query,
  where,
} from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";
import Swal from "sweetalert2";
import SwitchApariencia from '../SwitchApariencia.vue';
import { Offcanvas } from "bootstrap";
export default {
  name: "GoodBzzNavbar",

  components: {
    SwitchApariencia,
  },

  data() {
    return {
      usuario: {
        id: "",
        foto: "",
        nombre: "",
        idEmpresaSeleccionada: "",
      },
    }
  },

  mounted() {
    document.querySelector('#Navbar').addEventListener('click', function (event) {
      const empresasOffcanvas = Offcanvas.getInstance(document.getElementById(`empresasOffcanvas`));
      if(empresasOffcanvas){
        empresasOffcanvas.hide()
      }
    });
  },

  async created() {
    onAuthStateChanged(auth, async () => {
      let usuario = auth.currentUser;
      if (usuario) {
        let usuarioDB = await this.$store.state.obtenerUsuario(usuario.uid);
        if (usuarioDB) {
          await this.obtenerUsuario(usuarioDB.id);
        }
      }
    });
  },

  methods: {
    async obtenerUsuario(id) {
      onSnapshot(doc(db, "usuarios", id), async (doc) => {
        this.usuario.id = doc.id;
        this.usuario.foto = doc.data().foto;
        this.usuario.nombre = doc.data().nombre + " " + doc.data().apellido;
        if (doc.data().preferencias.idEmpresaSeleccionada) {
          this.usuario.idEmpresaSeleccionada = doc.data().preferencias.idEmpresaSeleccionada;
        } else {
          this.usuario.idEmpresaSeleccionada = "";
        }
      });
    },

    async cerrarSesion() {
      Swal.fire({
        icon: "info",
        title: "<h5>¿Deseas cerrar la sesión?</h5>",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "Cerrar Sesión",
        cancelButtonText: "Cancelar",
        reverseButtons: false,
        customClass: {
          popup: "swal-radius",
          confirmButton: "btn btn-primary btn-md fw-bold me-2 mb-3",
          cancelButton: "btn btn-secondary btn-md fw-bold mb-3",
        },
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then(async (result) => {
        if (result.value) {
          auth.signOut();
          this.usuario.id = null;
        }
      });
    },

    async irReporteSGSST() {
      let idLocalEmpresa = localStorage.getItem("idEmpresaSeleccionada");
      if (idLocalEmpresa) {
        this.$router.push("/empresas/" + idLocalEmpresa + "/reportesgsst")
      } else {
        let empresas = []
        const q = query(collection(db, "empresa"), where("idUsuario", "==", this.$store.state.usuario.id), orderBy("razonSocial", "desc"))
        const querySnapshot = await getDocs(q)
        querySnapshot.forEach((doc) => {
          empresas.push(doc.data())
        })
        if (empresas.length === 0) {
          Swal.fire({
            html: "¡Completa la información de tu empresa para acceder al <b>Reporte SG-SST</b>!",
            icon: 'info',
            confirmButtonColor: '#6127ff',
            confirmButtonText: '¡Completar!',
            allowEnterKey: false,
            allowEscapeKey: false,
            allowOutsideClick: false,
          }).then((result) => {
            if (result.isConfirmed) {
              this.$router.replace("/empresas/nueva")
            }
          })
        } else if (empresas.length === 1) {
          Swal.fire({
            html: `¡EMPRESA SELECCIONADA POR DEFAULT: <b>${empresas[0].razonSocial}</b>!`,
            icon: 'info',
            confirmButtonColor: '#6127ff',
            confirmButtonText: '<i class="fa fa-thumbs-up"></i>',
            allowEnterKey: false,
            allowEscapeKey: false,
            allowOutsideClick: false,
          }).then((result) => {
            if (result.isConfirmed) {
              this.$store.state.idEmpresaSeleccionada = empresas[0].id
              idLocalEmpresa = this.$store.state.idEmpresaSeleccionada
              localStorage.setItem("idEmpresaSeleccionada", idLocalEmpresa)
              this.$router.push("/empresas/" + idLocalEmpresa + "/reportesgsst")
              setTimeout(() => {
                this.$router.go(0)
              }, 1000)
            }
          })
        } else if (empresas.length > 1) {
          Swal.fire({
            html: "¡Debes seleccionar una empresa para acceder al <b>Reporte SG-SST</b>!",
            icon: 'info',
            confirmButtonColor: '#6127ff',
            confirmButtonText: '¡De acuerdo!',
            allowEnterKey: false,
            allowEscapeKey: false,
            allowOutsideClick: false,
          })
        }
      }
    },
  },
};
</script>

<style>
.navbar .offcanvas-backdrop {
  top: 65px !important;
}

.navbar.mt-4 .offcanvas-backdrop {
  top: 90px !important;
}
</style>

<style scoped>
/* TEMA CLARO */
a ion-icon,
a i {
  vertical-align: middle;
  color: #343434;
}

li ion-icon[name="help-circle"] {
  font-size: 25pt;
}

.navbar-toggler {
  border: 0;
  background: transparent;
  outline: none;
}

.navbar-toggler:focus,
.navbar-toggler:active,
.navbar-toggler:not(:active) {
  outline: none;
  box-shadow: none;
}

.navbar-toggler span {
  display: block;
  background-color: #6127ff;
  height: 3px;
  width: 25px;
  margin-top: 5px;
  margin-bottom: 5px;
  position: relative;
  left: 0;
  opacity: 1;
  transition: .1s ease-in-out;
  transform-origin: left;
}

#navbarOffcanvas.offcanvas.show~.navbar-toggler span:nth-child(1) {
  transform: translate(15%, -33%) rotate(45deg);
}

#navbarOffcanvas.offcanvas.show~.navbar-toggler span:nth-child(2) {
  opacity: 0;
}

#navbarOffcanvas.offcanvas.show~.navbar-toggler span:nth-child(3) {
  transform: translate(15%, 33%) rotate(-45deg);
}

.hidden {
  display: none;
}

.display {
  display: block;
}

::-webkit-scrollbar {
  width: 5.5px;
}

@media screen and (max-width: 990px) {
  .navbar-brand {
    flex-grow: 1 !important;
  }

  .offcanvas {
    border-top-right-radius: 25px;
    border-top-left-radius: 25px;
    padding: 15px 5px 15px 20px;
    margin-bottom: 43.5px;
  }

  #navbarOffcanvas {
    height: 430px !important;
  }

  #profileOffcanvas {
    height: 250px !important;
  }

  li .fas.fa-home {
    font-size: 18pt;
    margin-right: 14px;
  }

  li .fas.fa-building {
    font-size: 18pt;
    margin-right: 17px;
  }

  .img-community {
    margin-right: 14px;
  }

  .img-matrix-legal {
    margin-right: 10px;
  }

  li ion-icon[name="people"] {
    font-size: 20pt;
    margin-right: 11px;
  }

  li ion-icon[name="newspaper"],
  li ion-icon[name="git-pull-request"],
  li ion-icon[name="person-add"] {
    font-size: 20pt;
    margin-right: 10px;
  }

  li ion-icon[name="log-in-outline"] {
    font-size: 23pt;
    margin-right: 10px;
  }

  li ion-icon[name="people-circle"] {
    font-size: 23pt;
    margin-right: 9px;
    margin-left: -3px;
  }

  .img-support,
  .img-profile,
  .img-logout {
    margin-right: 12px;
  }

  li ion-icon[name="help-circle"] {
    margin-right: 5px;
    margin-left: -3px;
  }

  .hidden {
    display: inline-block;
  }

  .display {
    display: none;
  }

  .offcanvas a {
    font-size: 12pt;
    font-weight: 500;
    padding: 0px;
  }

  .offcanvas-body {
    overflow: hidden;
    margin-top: 10px;
  }

  .scroll-navbar {
    display: block;
    height: 320px;
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 10px;
  }

  .scroll-profile {
    display: block;
    padding-right: 10px;
  }

  .theme {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    padding: 0px 25px 10px 35px;
  }
}

/* TEMA OSCURO */
[data-bs-theme="dark"] .navbar {
  background: rgb(33, 33, 33) !important;
  border: none !important;
}

[data-bs-theme="dark"] .navbar-brand img,
[data-bs-theme="dark"] .nav-link img,
[data-bs-theme="dark"] .nav-link ion-icon,
[data-bs-theme="dark"] .nav-link i {
  filter: brightness(0) invert(1);
}

[data-bs-theme="dark"] .nav-link {
  color: #fff !important;
}

[data-bs-theme="dark"] .navbar-toggler span {
  background-color: #fff;
}
</style>